"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("utils/constants");
const cardContainerRoot = {
    boxShadow: '1px 2px 8px rgba(0, 109, 145, 0.1)',
    WebkitTransition: 'box-shadow 0.3s ease-in-out',
    MozTransition: 'box-shadow 0.3s ease-in-out',
    OTransition: 'box-shadow 0.3s ease-in-out',
    transition: 'box-shadow 0.3s ease-in-out',
};
const cardHeaderRoot = {
    display: 'flex',
    fontWeight: 'bold',
    fontSize: '1.2em',
    backgroundColor: 'rgba(0,0,0,.03)',
    borderBottom: '1px solid rgba(0,0,0,.125)'
};
const cardBodyRoot = {
    padding: 14
};
const cardFooterRoot = {
    display: 'flex',
    padding: '.75rem 1.25rem',
    backgroundColor: 'rgba(0,0,0,.03)',
    borderTop: '1px solid rgba(0,0,0,.125)'
};
const cardSummaryContainer = (theme) => ({
    padding: 24,
    marginBottom: 24,
    borderRadius: 10,
    boxShadow: 'rgb(0 109 145 / 10%) 1px 2px 8px',
    width: 'auto',
    color: theme === 'dark' ? constants_1.color.white : constants_1.color.black,
    backgroundColor: theme === 'dark' ? '#272936' : constants_1.color.white,
});
const cardSummaryBody = theme => ({
    padding: 0,
    color: theme === 'dark' ? constants_1.color.white : constants_1.color.black,
    borderColor: theme === 'dark' ? constants_1.color.white : constants_1.color.borderGrey,
    backgroundColor: theme === 'dark' ? '#272936' : constants_1.color.white,
});
const cardSummaryDate = theme => ({
    fontSize: 14,
    fontWeight: 600,
    color: theme === 'dark' ? constants_1.color.white : '#404041',
});
const cardSummarySeparator = theme => ({
    borderRight: theme === 'dark' ? '3px solid #fff' : '3px solid rgba(0, 0, 0, 0.15)'
});
const cardSummaryTitle = theme => ({
    fontSize: 24,
    color: theme === 'dark' ? constants_1.color.white : constants_1.color.lightGray,
    fontWeight: 600,
});
const tripSummaryAmount = {
    fontSize: 20,
    color: constants_1.color.red
};
const tripSummaryTitle = {
    fontSize: 12,
    marginLeft: 5,
    color: 'rgb(136, 136, 136)',
};
const cardTimeContractorBody = (theme) => ({
    padding: 24,
    width: '41vw',
    borderRadius: '10px',
    height: 'max-content',
    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.05)',
    color: theme === 'dark' ? constants_1.color.white : constants_1.color.black,
    backgroundColor: theme === 'dark' ? '#272936' : constants_1.color.white,
});
const cardTimeContractorHeader = {
    display: 'grid',
    marginBottom: 20,
    alignItems: 'center',
    gridTemplateColumns: 'max-content 3% auto',
};
const cardTimeContractorHeaderText = {
    fontSize: '20px',
    fontWeight: '600',
    marginRight: '5px',
};
const cardTimeContractorDetailsText = (theme) => ({
    display: 'flex',
    cursor: 'pointer',
    justifyContent: 'flex-end',
    color: theme === 'dark' ? '#9B9B9B' : '#EA0927',
});
const cardTimeContractorListRankWrapper = {
    columnGap: 12,
    display: 'grid',
    overflow: 'hidden',
    alignItems: 'center',
};
const cardTimeContractorListRankContainer = {
    margin: 0,
    width: 140,
    height: 110,
    display: 'flex',
    borderRadius: 10,
    padding: '16px 0',
    alignItems: 'center',
    flexDirection: 'column',
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
    border: '1px solid #E0E0E0',
};
const cardTimeContractorImgsWrapper = {
    width: '100%',
    display: 'flex',
    marginBottom: 12,
    padding: '0 12px',
    alignItems: 'center',
};
const cardTimeContractorListRankBody = (background) => ({
    width: 50,
    height: 50,
    padding: 5,
    color: 'white',
    display: 'flex',
    borderRadius: 10,
    alignItems: 'center',
    backgroundSize: 'cover',
    justifyContent: 'center',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundImage: `url(${background})`,
});
const cardTimeContractorListRankNumber = {
    fontSize: 20,
    lineHeight: 50,
    fontWeight: 700,
};
const cardTimeContractorRankDetailsImgs = (background) => ({
    height: 50,
    minWidth: 50,
    maxWidth: 50,
    marginLeft: 8,
    position: 'relative',
    backgroundSize: 'contain',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundImage: `url(${background})`,
});
const cardTimeContractorRankDetailsText = (index) => ({
    fontSize: 12,
    fontWeight: 600,
    textAlign: 'center',
    color: index == 0 ? '#AD8805' : index == 1 ? '#909090' : index == 2 ? '#B5936B' : '#323232',
});
exports.default = {
    cardContainerRoot,
    cardHeaderRoot,
    cardBodyRoot,
    cardFooterRoot,
    tripSummaryAmount,
    tripSummaryTitle,
    cardSummaryBody,
    cardSummaryDate,
    cardSummaryTitle,
    cardSummaryContainer,
    cardSummarySeparator,
    cardTimeContractorBody,
    cardTimeContractorHeader,
    cardTimeContractorHeaderText,
    cardTimeContractorDetailsText,
    cardTimeContractorImgsWrapper,
    cardTimeContractorListRankBody,
    cardTimeContractorListRankNumber,
    cardTimeContractorListRankWrapper,
    cardTimeContractorRankDetailsImgs,
    cardTimeContractorRankDetailsText,
    cardTimeContractorListRankContainer,
};
